module.exports = __webpack_public_path__ + "img/placeholder.31918fa.svg";